var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import DeleteModal from '@/common/delete-modal';
import Header from '@/common/header';
import SidePanel from '@/common/side-panel';
import MetadataUpdateModal from '@/common/update-config-modal';
import { useUpdateContext } from '@/contextProvider/context.provider';
import { useMutation } from '@/hoc/hooks/useMutation';
import { useQuery } from '@/hoc/hooks/useQuery';
import { DownArrow, EditIcon, TrashIcon, UpArrow } from '@/icons';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
var initialData = [];
var columns = [
    { label: 'Config', key: 'config', mobilePriority: true },
    { label: 'Database', key: 'database', mobilePriority: true },
    { label: 'Table', key: 'table', mobilePriority: false },
    { label: 'Fields', key: 'fields', mobilePriority: false },
    { label: 'Saved on', key: 'savedon', mobilePriority: false },
    { label: 'Edit', key: 'edit', mobilePriority: true },
    { label: 'Delete', key: 'delete', mobilePriority: true },
];
export default function ConfiguredList() {
    var _a = useState(true), sidePanelOpen = _a[0], setSidePanelOpen = _a[1];
    var _b = useState(initialData), data = _b[0], setData = _b[1];
    var _c = useState(null), selectedRowIndex = _c[0], setSelectedRowIndex = _c[1];
    var _d = useState(false), showModal = _d[0], setShowModal = _d[1];
    var _e = useState(false), showUpdateModal = _e[0], setShowUpdateModal = _e[1];
    var navigate = useNavigate();
    var _f = useState(false), isMobile = _f[0], setIsMobile = _f[1];
    var _g = useState(null), deleteId = _g[0], setDeleteId = _g[1];
    var _h = useState(null), selectedEntry = _h[0], setSelectedEntry = _h[1];
    // Use the update context
    var setUpdateRowData = useUpdateContext().setUpdateRowData;
    var apiResponse = useQuery('/metadatadbdetails/getconfigdetails').data;
    var _j = useMutation(), deleteTrigger = _j.trigger, deleteData = _j.data, deleteLoading = _j.loading, deleteError = _j.error;
    var _k = useMutation(), updateTrigger = _k.trigger, updateData = _k.data, updateLoading = _k.loading, updateError = _k.error;
    useEffect(function () {
        var checkIfMobile = function () {
            setIsMobile(window.innerWidth < 768);
            if (window.innerWidth < 768) {
                setSidePanelOpen(false);
            }
        };
        checkIfMobile();
        window.addEventListener('resize', checkIfMobile);
        return function () { return window.removeEventListener('resize', checkIfMobile); };
    }, []);
    var sortData = function (key, direction) {
        var sorted = __spreadArray([], data, true).sort(function (a, b) {
            var _a, _b, _c, _d;
            if (((_a = a[key]) !== null && _a !== void 0 ? _a : '') < ((_b = b[key]) !== null && _b !== void 0 ? _b : ''))
                return direction === 'asc' ? -1 : 1;
            if (((_c = a[key]) !== null && _c !== void 0 ? _c : '') > ((_d = b[key]) !== null && _d !== void 0 ? _d : ''))
                return direction === 'asc' ? 1 : -1;
            return 0;
        });
        setData(sorted);
    };
    var handleDelete = function () {
        if (selectedRowIndex !== null) {
            deleteTrigger("/metadatadbdetails?id=".concat(deleteId), 'DELETE', '')
                .then(function (res) {
                setData(function (prev) {
                    return prev.map(function (item, idx) { return (idx === selectedRowIndex ? __assign(__assign({}, item), { deleted: true }) : item); });
                });
                setShowModal(false);
                setSelectedRowIndex(null);
                toast.success('Row deleted successfully!');
            })
                .catch(function (err) {
                console.error('Error:', err);
                toast.error('Failed to delete row. Please try again.');
            });
        }
    };
    // Helper function to handle edit click
    var handleEditClick = function (row) {
        // Set the row data in context
        setUpdateRowData(row);
        // Navigate to metadata selection page
        navigate("/metadata-selection");
    };
    // Helper function to get table names from the table object
    var getTableNames = function (tableObj) {
        if (!tableObj)
            return 'N/A';
        if (tableObj.all === true) {
            return 'All Tables/Collections';
        }
        var tableNames = Object.keys(tableObj).filter(function (key) { return key !== 'all'; });
        return tableNames.length > 0 ? tableNames.join(', ') : 'N/A';
    };
    // Helper function to get fields information from the table object
    var getFieldsInfo = function (tableObj) {
        if (!tableObj)
            return 'N/A';
        if (tableObj.all === true) {
            return 'All Fields';
        }
        var tableNames = Object.keys(tableObj).filter(function (key) { return key !== 'all'; });
        var fieldsInfo = [];
        for (var _i = 0, tableNames_1 = tableNames; _i < tableNames_1.length; _i++) {
            var tableName = tableNames_1[_i];
            var tableConfig = tableObj[tableName];
            if (tableConfig.all === true) {
                fieldsInfo.push("".concat(tableName, ": All Fields"));
            }
            else if (tableConfig.fields && Array.isArray(tableConfig.fields)) {
                var fieldNames = tableConfig.fields.map(function (field) { return field.field; }).join(', ');
                fieldsInfo.push("".concat(tableName, ": ").concat(fieldNames));
            }
        }
        return fieldsInfo.length > 0 ? fieldsInfo.join(' | ') : 'N/A';
    };
    var updateFunction = function (updatedEntry) {
        updateTrigger("/metadatadbdetails", 'PUT', __assign(__assign({}, updatedEntry), { id: updatedEntry._id }))
            .then(function (res) {
            var newData = data.map(function (item) {
                if (item._id === updatedEntry._id) {
                    return __assign(__assign({}, item), updatedEntry);
                }
                return item;
            });
            setData(newData);
            setShowUpdateModal(false);
            toast.success('Row updated successfully!');
        })
            .catch(function (err) {
            console.error('Error:', err);
            toast.error('Failed to update row. Please try again.');
        });
    };
    useEffect(function () {
        setData((apiResponse === null || apiResponse === void 0 ? void 0 : apiResponse.data) || []);
    }, [apiResponse]);
    // Filter out deleted items before rendering
    var visibleData = data.filter(function (item) { return !item.deleted; });
    return (_jsxs("div", { className: 'flex min-h-screen bg-gray-50', children: [_jsx(SidePanel, { open: sidePanelOpen, onMenuClick: function () { return setSidePanelOpen(function (prev) { return !prev; }); }, isMobile: isMobile }), _jsx("div", { className: "flex-1 transition-all duration-300 ".concat(isMobile ? 'ml-0' : sidePanelOpen ? 'md:ml-0' : 'md:ml-0'), children: _jsxs("div", { className: 'p-2 md:p-2', children: [_jsx(Header, {}), _jsx("div", { className: 'flex flex-col md:flex-row md:justify-between md:items-center mb-6 gap-4', children: _jsx("h1", { className: 'text-xl md:text-2xl font-semibold text-gray-800', children: "Configured List" }) }), _jsxs("div", { className: 'bg-white p-4 md:p-6 rounded-xl shadow min-h-screen overflow-x-auto', children: [_jsx("h2", { className: 'text-lg md:text-xl font-semibold text-gray-800 mb-4', children: "All Lists" }), _jsx("div", { className: 'hidden md:block', children: _jsxs("table", { className: 'w-full table-auto text-sm border-collapse', children: [_jsx("thead", { children: _jsx("tr", { className: 'border-b border-gray-300', children: columns.map(function (col, idx) { return (_jsx("th", { className: 'px-2 py-1 font-semibold text-left', children: _jsxs("div", { className: 'flex items-center justify-between', children: [_jsx("span", { children: col.label }), col.key !== 'edit' && col.key !== 'delete' && (_jsxs("div", { className: 'flex flex-col ml-1 text-gray-500 leading-none', children: [_jsx("button", { onClick: function () { return sortData(col.key, 'asc'); }, className: 'p-0 h-3 hover:text-gray-700', children: _jsx(UpArrow, { className: 'w-2 h-2' }) }), _jsx("button", { onClick: function () { return sortData(col.key, 'desc'); }, className: 'p-0 h-3 hover:text-gray-700', children: _jsx(DownArrow, { className: 'w-2 h-2' }) })] }))] }) }, idx)); }) }) }), _jsx("tbody", { children: visibleData.map(function (row, idx) { return (_jsxs("tr", { className: 'border-gray-300 hover:bg-gray-50', children: [_jsx("td", { className: 'px-2 py-1', children: row.configName }), _jsx("td", { className: 'px-2 py-1', children: row.DBName }), _jsx("td", { className: 'px-2 py-1', children: _jsx("div", { className: 'max-w-xs break-words', children: getTableNames(row.table) }) }), _jsx("td", { className: 'px-2 py-1', children: _jsx("div", { className: 'max-w-xs break-words', children: getFieldsInfo(row.table) }) }), _jsx("td", { className: 'px-2 py-1', children: new Date(row.insertedAt).toLocaleString() }), _jsx("td", { className: 'px-2 py-1 cursor-pointer', onClick: function () { return handleEditClick(row); }, children: _jsx(EditIcon, { className: 'w-4 h-4' }) }), _jsx("td", { className: 'px-2 py-1 ', children: _jsx("button", { className: 'text-red-600 hover:text-red-800 cursor-pointer', onClick: function () {
                                                                    setSelectedRowIndex(data.indexOf(row));
                                                                    setShowModal(true);
                                                                    setDeleteId((row === null || row === void 0 ? void 0 : row._id) || '');
                                                                }, children: _jsx(TrashIcon, { className: 'w-4 h-4' }) }) })] }, idx)); }) })] }) }), _jsx("div", { className: 'md:hidden space-y-4', children: visibleData.map(function (row, idx) { return (_jsxs("div", { className: 'border border-gray-200 rounded-lg p-4 hover:bg-gray-50', children: [_jsxs("div", { className: 'grid grid-cols-2 gap-4 mb-3', children: [_jsxs("div", { children: [_jsx("p", { className: 'text-xs text-gray-500', children: "Config" }), _jsx("p", { className: 'font-medium', children: row.configName })] }), _jsxs("div", { children: [_jsx("p", { className: 'text-xs text-gray-500', children: "Database" }), _jsx("p", { className: 'font-medium', children: row.DBName })] }), _jsxs("div", { children: [_jsx("p", { className: 'text-xs text-gray-500', children: "Table" }), _jsx("p", { className: 'font-medium break-words', children: getTableNames(row.table) })] }), _jsxs("div", { children: [_jsx("p", { className: 'text-xs text-gray-500', children: "Fields" }), _jsx("p", { className: 'font-medium text-xs break-words', children: getFieldsInfo(row.table) })] }), _jsxs("div", { className: 'col-span-2', children: [_jsx("p", { className: 'text-xs text-gray-500', children: "Saved on" }), _jsx("p", { className: 'font-medium', children: new Date(row.insertedAt).toLocaleString() })] })] }), _jsx("div", { className: 'flex justify-between items-center border-t border-gray-100 pt-3', children: _jsxs("div", { className: 'flex gap-3', children: [_jsx("button", { className: 'text-blue-600 hover:text-blue-800', onClick: function () { return handleEditClick(row); }, children: _jsx(EditIcon, { className: 'w-4 h-4' }) }), _jsx("button", { className: 'text-red-600 hover:text-red-800', onClick: function () {
                                                                setSelectedRowIndex(data.indexOf(row));
                                                                setShowModal(true);
                                                                setDeleteId((row === null || row === void 0 ? void 0 : row._id) || '');
                                                            }, children: _jsx(TrashIcon, { className: 'w-4 h-4' }) })] }) })] }, idx)); }) })] })] }) }), _jsx(MetadataUpdateModal, { isOpen: showUpdateModal, onClose: function () { return setShowUpdateModal(false); }, onUpdate: function (updatedEntry) {
                    updateFunction(updatedEntry);
                }, data: selectedEntry }), _jsx(DeleteModal, { isOpen: showModal, onClose: function () {
                    setShowModal(false);
                    setSelectedRowIndex(null);
                }, onConfirm: handleDelete })] }));
}
